// Vendor imports
const Immutable = require('immutable')
// Client v2 common imports
const ArticleProfileModalRecord = require('client-v2/common/containers/article-profile/state/modal-record')
const AuthModalRecord = require('client-v2/common/containers/auth-modal/record')
const EnvRecord = require('client-v2/common/state/env/record')
const RouterRecord = require('client-v2/common/state/router/record')
const GlobalUserRecord = require('client-v2/common/state/user/record')
const { keyedReviver } = require('client-v2/common/state/record-reviver')
// Entry imports
const FeedRecord = require('../containers/feed/record')
const SearchQueryRecord = require('../containers/query/record')

class SearchRootRecord extends Immutable.Record({
  // Global common state
  env: null,
  router: null,
  user: null,
  // Common containers
  articleProfileModal: null,
  authModal: null,
  // Entry state
  feed: null,
  query: null
}) {
  // No methods
}

SearchRootRecord.reviver = keyedReviver(SearchRootRecord, {
  // Common state records
  env: EnvRecord.reviver,
  router: RouterRecord.reviver,
  user: GlobalUserRecord.reviver,
  // Common container records
  articleProfileModal: ArticleProfileModalRecord.reviver,
  authModal: AuthModalRecord.reviver,
  // Entry state records
  feed: FeedRecord.reviver,
  query: SearchQueryRecord.reviver
})

module.exports = SearchRootRecord
